import React from "react";

export default function AboutHeader() {
  return (
    <section className="bg-about-page-banner w-full bg-cover bg-center py-36 md:py-56 lg:py-64 text-center">
      <h1 className="text-4xl md:text-5xl lg:text-7xl text-[#2c541d] font-medium tracking-widest	">
        WHO ARE WE?
      </h1>
    </section>
  );
}
